export default __webpack_public_path__ + "static/media/yash_and_radhika.b51ae554.jpg";